export default "/images/goal.png?d09db210ca868522df0fc7dd74d5ee69";